import { LabelType, LabelDto } from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function getLabelsByType(labelType: LabelType): Promise<LabelDto[]> {
  return httpClient.get(`labels/${labelType}`).json();
}

export async function saveLabel(labelType: LabelType, name: string): Promise<LabelDto> {
  return httpClient.post(`labels/${labelType}`, { json: { name } }).json();
}
